module.exports = __webpack_public_path__ + "static/img/Alex-Dodson.b05ea35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alex-Dodson.jpg
// module id = 76xX
// module chunks = 0